import React, {useState} from "react";
import PropTypes from "prop-types";
import { DatePicker } from "react-md";
import { ClearButton } from "components/Shared";

const DateField = ({
  label,
  innerRef,
  onChange,
  defaultValue,
  onClear,
  ...otherProps
}) => {
    const [visible, setVisible] = useState(defaultValue);
    return (<>
      {label}
      <DatePicker
        {...otherProps}
        ref={innerRef}
        {...{defaultValue}}
        onChange={(...args) => {
          onChange(...args);
          setVisible(true);
        }}
        autoOk
        portal
        lastChild
        renderNode={null}
        locales={"en-US"}
        disableScrollLocking
      />
      <ClearButton 
        {...{visible}}
        onClick={() => {
          onClear();
          setVisible(false);
        }}
      />
    </>);
};

DateField.defaultProps = {
  label: "",
  onChange: () => {},
  defaultValue: null,
  onClear: () => {},
  innerRef: {},
};

DateField.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  innerRef: PropTypes.object,
  onChange: PropTypes.func,
  defaultValue: PropTypes.string,
  onClear: PropTypes.func,
};

export default DateField;